import { RootState } from "../../redux-store";
import { FeatureName } from "dora-contracts";

export const selectFeature = (feature: FeatureName) => (state: RootState) => {
  return state.features[feature]?.enabled || false;
};
